export function withTimeout<T>(promise: Promise<T>, ms: number, timeoutMessage = `Operation timed out after ${ms}ms`): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(timeoutMessage));
    }, ms);

    promise
      .then(resolve)
      .catch(reject)
      .finally(() => clearTimeout(timeoutId));
  });
}
